export default {
  translations: {
    home: {
      welcome: "Boas vindas!",
    },
    header: {
      menu: {
        portal: "Portal",
        planning: "Planejamento",
        production: "Produção",
        requests: "Pedidos",
        deliveries: "Entregas",
        stock: "Estoque",
        dashboard: "Dashboard",
      },
      submenu: {
        portal: {
          portalParameters: "Parâmetros do Portal",
          parameters: "Parâmetros",
          partner: "Parceiro",
          agregatedPartner: "Parceiro Agregado",
          parameterPartner: "Parâmetros do Parceiro",
          profile: "Perfil",
          user: "Usuário",
          passwordChange: "Troca de Senha",
          ssoConfig: "Configuração do SSO",
          basicData: "Dados Básicos",
          emailGroups: "Grupos de E-mails",
        },
        planning: {
          justification: "Justificativa",
          projects: "Projetos",
          contract: "Contrato",
          monthlyForecats: "Forecast Mensal",
          dailyForecats: "Forecast Diário",
          stuffRequest: "Solicitação de Matéria Prima",
        },
        production: {
          dailyProductionRelease: "Lançamento Diário de Produção",
          deviationsApproval: "Aprovação de Desvios",
        },
        requests: {
          finishedProduct: "Produto Acabado",
          importRequest: "Pedido Importação",
        },
        deliveries: {
          fob: "FOB",
          cif: "CIF",
          stuff: "Matéria Prima",
        },
        stock: {
          brfPartner: "Parceiro BRF",
          partner: "Parceiro",
        },
        dashboad: {
          productionMonitoring: "Acompanhamento de Produção",
          contractualConsumption: "Consumo Contratual",
          import: "Importação",
          partnerMonitoring: "Acompanhamento Parceiros",
        },
      },
      selectPartner: "Selecione um Parceiro",
      partner: "Parceiro",
      partnerTooltip:
        "Mostra lista de Parceiros para selecionar o parceiro cujos dados serão apresentados !",
      account: {
        myAccount: "Minha conta",
        changePass: "Alteração de senha",
        logout: "Logout",
      },
    },
    pages: {
      portalParameters: {
        title: "Parâmetros do Portal",
        text: {
          parameter: "Parâmetro",
          routine: "Rotina",
          value: "Valor",
          newParameter: "Novo parâmetro",
          successNew: "Parâmetro adicionado com sucesso!",
          successUpdate: "Parâmetro atualizado com sucesso!",
          successExclusion: "Parâmetro excluído com sucesso!",
          updateParameterData: "Atualizar dados do Parâmetro",
          excludeItemQuestionTitle: "Exclusão de Item do Contrato?",
          excludeItemQuestionSubTitle:
            "Você solicitou a exclusão do parâmetro.",
          excludeItemQuestionConfirmation: "Confirma a operação?",
          searchRoutine: "Buscar Rotina",
        },
      },
      parameters: {
        title: "Parâmetros",
        text: {
          parameter: "Parâmetro",
          properties: "Propriedades",
          value: "Valor",
          newParameter: "Novo parâmetro",
          successNew: "Propriedade adicionada com sucesso!",
          successUpdate: "Propriedade atualizada com sucesso!",
          successExclusion: "Propriedade excluída com sucesso!",
          updateParameterData: "Atualizar dados do Parâmetro",
          excludeItemQuestionTitle: "Exclusão de Item do Contrato?",
          excludeItemQuestionSubTitle:
            "Você solicitou a exclusão do parâmetro.",
          excludeItemQuestionConfirmation: "Confirma a operação?",
          searchRoutine: "Buscar Rotina",
          modalTitle: "Exclusão de Item do Contrato?",
          modalText: "Você solicitou a exclusão do parâmetro.",
          modalText2: "Parâmetro : ",
          modalText3: "Valor : ",
          modalText4: "Confirma a Operação?",
        },
      },
      partners: {
        titlePage: "Parceiros",
        titleList: "Listagem de parceiros",
        titleDetails: "Detalhes do parceiro",
        text: {
          sapCode: "Cod. SAP",
          sapSupplier: "Fornecedor SAP",
          status: "Status",
          partnersFilter: "Filtrar parceiros",
          removeFilters: "Remover filtros",
          blockPartner: "Bloquear Parceiro",
          unlockPartner: "Desbloquear Parceiro",
          blockSuccess: "Parceiro bloqueado com sucesso!",
          restoreSuccess: "Parceiro restaurado com sucesso!",
          savePartnerData: "Salvar dados do parceiro",
          updateSuccess: "Dados atualizados com sucesso!",
          updateFail: "Não foi possível atualizar os dados do parceiro.",
          backToList: "Voltar à listagem",
          partnerEmail: "Email do parceiro",
          partnerEmails: "Emails do parceiro",
          partnerDataUpdate: "Atualizar dados do Parceiro",
          filterOfPartners: "Filtro de parceiros",
          filterOptions: "Você pode pesquisar por nome, código SAP ou apelido.",
          autoCompleteNoOptions:
            "Sem opções, solicite acesso ao administrador.",
        },
      },
      partnerParameters: {
        titlePage: "Parâmetros do parceiro",
        text: {
          paramSearch: "Buscar parâmetro",
          property: "Propriedade",
          parameter: "Parâmetro",
          value: "Valor",
          newParameter: "Novo parâmetro",
          updateParameter: "Atualizar dados do parâmetro",
          successNewProperty: "Propriedade adicionada com sucesso!",
          successUpdateProperty: "Propriedade atualizada com sucesso!",
          successExclusionProperty: "Propriedade excluída com sucesso!",
          recoverDataFailure:
            "Erro ao recuperar os dados de Parâmetros do Parceiro!",
          excludeSuccess: "Parâmetro Excluido com sucesso!",
          excludeItemQuestionTitle: "Exclusão de Item do Contrato?",
          excludeItemQuestionSubTitle:
            "Você solicitou a exclusão do parâmetro.",
          excludeItemQuestionConfirmation: "Confirma a operação?",
        },
      },
      user: {
        titlePage: "Usuário",
        text: {
          password: "Senha",
          generateRandomPassword: "Gerar senha aleatória",
          accessFails: "Falhas de Acesso",
          profile: "Perfil",
          newUser: "Novo usuário",
          userPartners: "Parceiros do usuário",
          userRelatedPartners: "Parceiros vinculados ao usuário",
          userDataUpdate: "Atualizar dados do usuário",
          userDataDelete: "Apagar dados do usuário",
          preSelectedFieldsSearch:
            "Realizar busca por campos pré-selecionados!",
          lockedForLogin: "Bloqueado para login",
          unlockedForLogin: "Desbloqueado para login",
          requiredEmailField: "O campo Email é obrigatório.",
          requiredNameField: "O campo Nome é obrigatório.",
          requiredPasswordField: "O campo Senha é obrigatório.",
          requiredPartnetField: "Selecione ao menos um parceiro.",
          invalidEmailField: "Formato do email inválido.",
          saveUser: "Salvar usuário",
          successSaveUser: "Usuário salvo com sucesso.",
          deleteUser: "Excluir usuário",
          successDeleteUser: "Usuário excluído com sucesso.",
          searchFieldNotRecognized: "Campo de pesquisa não reconhecido.",
          userWith: "Usuário com",
          notFounded: "não encontrado.",
          searchUser: "Buscar usuário",
          userRootWarning:
            "O usuário root possui acesso a todos os parceiros não sendo necessário vincula-los.",
          understand: "Entendi",
          selectFieldandValueToSearch:
            "Selecione o Campo e o valor a pesquisar",
          field: "Campo",
          partners: "Parceiros",
        },
      },
      password: {
        titlePage: "Alteração de senha",
        text: {
          passwordChange: "Alteração de senha",
          passwordUpdate: "Atualizar senha",
          actualPassword: "Senha atual",
          newPassword: "Nova senha",
          newPasswordConfirmation: "Senha nova confirmação",
          passwordChangeSuccess:
            "Senha alterada com sucesso, você será redirecionado(a) a tela de login!",
          passwordChangeFailure:
            "Não foi possível alterar sua senha. Reveja os passos e tente novamente!",
          confirm: "Confirmar Operação",
          confirmQuestion: "Tem certeza de que deseja {{texto}} a senha?",
          oldPasswordRequired: "Senha Antiga tem que ser informada!",
          newPasswordRequired: "Uma nova senha deve ser informada!",
          newPasswordConfirmationRequired:
            "Confirmação da nova senha deve ser fornecida!",
          passwordsNotMatched: "Senhas não conferem!",
          newPasswordAndOldPasswordEqual:
            "Senha antiga e senha nova não podem ser iguais!",
          pleaseVerify: "Favor verificar o",
          verifyItemPlural: "seguintes itens:",
          verifyItemSingular: "seguinte item:",
          fillingError: "Inconformidades de Preenchimento",
        },
      },
      basicData: {
        titlePage: "Dados básicos",
        text: {
          sapSupplierCode: "Código Fornecedor SAP",
          sapClientCode: "Código Cliente SAP",
          partners: "Parceiros",
          sku: "Sku",
          distributionCenter: "Centro de distribuição",
        },
      },
      emailsGroups: {
        titlePage: "Grupos de E-mails",
        text: {
          emails: "E-mails",
          routine: "Rotina",
          routines: "Rotinas",
          registeredEmails: "E-mails cadastrados",
          registeredGroups: "Grupos cadastrados",
          emailCreatedWithSuccess: "E-mail criado com sucesso",
          emailRemovedWithSuccess: "E-mail excluido com sucesso!",
          registerUpdatedWithSuccess: "Registro atualizado com sucesso",
          savingDataFrom: "Salvando data de ",
          groupRemovedWithSuccess: "Grupo excluído com sucesso",
          emailRegister: "Cadastrar e-mail",
          emailRemove: "Apagar e-mail",
          groupRegister: "Cadastrar grupo",
          groupRemove: "Apagar grupo",
          emailAddToGroupWithSuccess: "E-mail adicionado ao grupo com sucesso",
          linkedEmails: "E-mails vinculados",
          addEmail: "Adicionar e-mail",
          routineCreatedWithSuccess: "Rotina criada com sucesso",
          routineAddedToGroupWithSuccess:
            "Rotina adicionada ao grupo com sucesso",
          routineRemovedWithSuccess: "Rotina excluída com sucesso",
          linkedRoutines: "Rotinas vinculadas",
          addRoutine: "Adicionar rotina",
        },
      },
      justifications: {
        titlePage: "Justificativas",
        text: {
          successNewProperty: "Propriedade adicionada com sucesso!",
          successUpdateProperty: "Propriedade atualizada com sucesso!",
          justificationExclusionWithSuccess:
            "Justificativa Excluida com sucesso!",
          newJustification: "Nova justificativa",
          updateParametersData: "Atualizar dados do parâmetro",
          excludeItemQuestionTitle: "Exclusão de Justificativa?",
          excludeItemQuestionSubTitle:
            "Você solicitou a exclusão da Justificativa.",
          excludeItemQuestionConfirmation: "Confirma a operação?",
          justification: "Justificativa",
        },
      },
      projects: {
        titlePage: "Projetos",
        text: {
          successNewProject: "Projeto adicionada com sucesso!",
          successUpdateProject: "Projeto atualizada com sucesso!",
          projectExclusionWithSuccess: "Projeto Excluida com sucesso!",
          newProject: "Novo projeto",
          updateProjectData: "Atualizar dados do projeto",
          excludeItemQuestionTitle: "Exclusão de Projeto?",
          excludeItemQuestionSubTitle: "Você solicitou a exclusão do Projeto.",
          excludeItemQuestionConfirmation: "Confirma a operação?",
          project: "Projeto",
          projectName: "Nome do Projeto",
        },
      },
      contracts: {
        titlePage: "Contratos",
        titleList: "Relação de Contratos",
        text: {
          newContract: "Novo contrato",
          contractItems: "Items do contrato",
          contractItem: "Item do contrato",
          contract: "Contrato",
          warningStartDate:
            "Data do Início da Vigência deve ser menor que a Data do Fim!",
          warningContractNumber:
            "Já existe esse nº de contrato para esse Parceiro, a duplicidade não será permitida, favor ajustar!",
          saveContract: "Salvar contrato",
          informContractNumber: "Informe o nº do contrato",
          saveWithSuccess: "Contrato salvo com sucesso!",
          excludeContract: "Excluir contrato",
          excludeWithSuccess: "Contrato excluído com sucesso!",
          excludeError: "Erro ao tentar excluir o contrato",
          addItemToContract: "Adicionar item ao contrato",
          updateContractItem: "Atualizar item do contrato",
          addItemsToContract: "Adicionar items ao contrato",
          contractItemDeleteWithSuccess:
            "Item do Contrato excluído com sucesso!",
          contractItemDeleteError: "Erro ao tentar excluir item do contrato!",
          contractItemUpdateWithSuccess:
            "Item do Contrato Atualizado com sucesso!",
          itemUpdateWithSuccess: "Item atualizado com sucesso!",
          generateMonthlyForecast: "Gerar Forecast Mensal",
          monthlyForecats: "Forecast Mensal",
          monthlyForecatsContinue:
            "Deseja prosseguir com a criação do forecast mensal?",
          reverseForecast: "Estornar forecast",
          reverseForecastProceed:
            "Deseja prosseguir com o Estorno do Forecast?",
          reverseForecastSuccess: "Estorno de Forecast realizado com sucesso!",
          reverseForecastUnsuccessful:
            "O Estorno do Forecast não foi realizado!",
          contractForecast: "Forecast do contrato",
          forPartner: "para o parceiro",
          andSku: "e para o SKU",
          generatedWithSuccess: "foi gerado com sucesso!",
          contractNumber: "Nº do Contrato",
          priceFrequency: "Freq. Atual. Preço (Mês)",
          agreedPenalty: "Multa acordada",
          penalty: "Multa",
          beginningOfTerm: "Início da vigência *",
          endOfTerm: "Fim da vigência *",
          shippingMode: "Modalidade de frete *",
          modalExit: "Sair do modal",
          yearReference: "Ano Ref",
          anualQuantity: "Quantidade anual",
          excludeItemQuestionTitle: "Exclusão do Contrato?",
          excludeItemQuestionSubTitle: "Você solicitou a exclusão do contrato.",
          excludeItemQuestionConfirmation: "Confirma a operação?",
          excludeItemQuestionTitle2: "Exclusão do item do Contrato?",
          excludeItemQuestionSubTitle2:
            "Você solicitou a exclusão do item do contrato.",
          excludeItemQuestionConfirmation2: "Confirma a operação?",
          removeItem: "Deletar item",
          blockStuff: "Bloquear material",
          unblockStuff: "Desbloquear material",
          project: "Projeto",
          titlePenalty: "Multa acordada",
          contractDetails: "Detalhes do contrato",
          contractModalTitle: "Origens e Contratos SAP",
        },
      },
      monthlyForecast: {
        titlePage: "Forecast Mensal",
        text: {
          defineBasePlan: "Definir plano base",
          suggestChanges: "Sugerir alterações",
          approveDisapproveProposal: "Aprovar/Reprovar proposta",
          frozenAndDiarized: "Congelado e Diarizado",
          allStepsHaveBeenCompleted: "Todas as etapas foram cumpridas.",
          includingForecastGeneration: "Incluindo geração de previsão.",
          itIsStillPossibleToChangeContractData:
            "Ainda é possível alterar os dados do contrato,",
          howeverRecreateTheForecast:
            "No entanto, não será possível recriar a previsão para os SKU's e exercícios já criados!",
          theFinalStep:
            "O último passo será realizado para os SKUs incluídos após a última geração de previsão em:",
          contractConsumption: "Consumo contrato",
          exitModal: "Sair do modal",
          sAPSupplierCode: "Código fornecedor SAP",
          contractNumber: "Número do contrato",
          percentageConsumed: "Percentual Consumido",
          approvalDataTitle:
            "Aprova os dados do(s) Item(ns) selecionado(s) na lista abaixo, e avança para a próximo etapa!",
          approvalDataTitle2:
            "Caso não tenha sido gerado, essa operação irá gerar o Forecast 'Diarizado'!",
          contractNotSelected: "Contrato não selecionado",
          withoutContract: "Sem contrato!",
          integratedSelectedItems:
            "Os {{quantityItems}} itens selecionados na grid foram integrados com sucesso! ",
          integratedSelectedItems2:
            "O item selecionado na grid foi integrado com sucesso!",
          updatedSelectedItems:
            "Os {{quantityItems}} itens selecionados na grid foram atualizados com sucesso! ",
          updatedSelectedItems2:
            "O item selecionado na grid foi atualizado com sucesso!",
          errorSelectedItems:
            "Os {{quantityItems}} itens selecionados na grid foram enviados, mas alguns NÃO foram processados com sucesso! ",
          errorSelectedItems2: "O item selecionado na grid NÃO foi atualizado!",
          proposalQuantityIsWrong:
            "Campo Quantidade Proposta foi preenchido com um valor diferente da Quantidade, favor informar uma Justificativa! ",
          rememberThisOperation:
            "Lembre-se que essa operação também contempla a INTEGRAÇÃO com SAP!",
          selectedItemsNextForecast:
            "Os {{quantityItems}} itens selecionados na grid foram aprovados e encontram-se na próxima etapa do 'WorkFlow'!",
          selectedItemsNextForecast2:
            "O item selecionado na grid foi aprovado e encontra-se na próxima etapa do 'WorkFlow'!",
          selectedItemsNextForecastError:
            "Os {{quantityItems}} itens selecionados na grid NÃO foram aprovados e encontram-se na etapa anterior do 'WorkFlow'! ",
          selectedItemsNextForecastError2:
            "O item selecionado na grid NÃO foi aprovado e encontra-se na etapa anterior do 'WorkFlow'! ",
          selectedItemsProcessedWithError:
            "Os {{quantityItems}} itens selecionados na grid foram processados com Erro! ",
          selectedItemsProcessedWithError2:
            "O item selecionado na grid NÃO foi processado corretamente!",
          selectedItemsDoesNotProcessed:
            "Os {{quantityItems}} itens selecionados na grid NÃO foram processados corretamente!",
          selectedItemsDoesNotProcessed2:
            "O item selecionado na grid NÃO foi processado corretamente!",
          monthYearRef: "Mês ano ref.",
          processingRequest:
            "O processamento de sua solicitação levará aproximadamente",
          processingRequest2: "segundos. Por favor, Aguarde !",
          negativeValues: "Valores negativos não são permitidos!",
          undoGeneratedForecasts: "Desfazer Forecasts gerados",
          viewRatioData: "Exibir dados de proporção",
          enablesFilteringTheLinesInTheGridBelow:
            "Habilita filtrar as linhas da grid abaixo!",
          disableFilteringTheLinesInTheGridBelow:
            "Desabilita filtro e retorna todas as linhas da grid abaixo!",
          saveChanges:
            "Salvar alterações no Item selecionado na Grid abaixo, SEM avançar para o próximo etapa!",
          uploadCsv: "Carregar arquivo csv e atualizar a lista abaixo!",
          downloadCsv:
            "Download o arquivo csv para ser atualizado e carregado!",
          continueForecast: "Deseja continuar o Forecast Mensal?",
          reproveData:
            "Reprova os dados do(s) Item(ns) selecionado(s) na lista abaixo, e os retorna para a etapa anterior!",
          sendDataToSap:
            "Envia para o SAP os dados do(s) item(ns) selecionado(s) na lista abaixo, e NÃO avança ou retrocede etapa!",
          importExcel: "Importação de Planilha Excel!",
          csvWithSuccess: "CSV Processado com Sucesso!",
          csvWithError: "Não foi possível processar o CSV",
        },
      },
      dailyForecast: {
        titlePage: "Forecast Diário",
        text: {
          exitModal: "Sair do modal",
          whenToMoveProduction: "Para quando mover a produção?",
          forecastDate: "Data de Forecast",
          resetForecastForTheDay: "Isso irá zerar o forecast do dia",
          movingQuantity: " movendo sua quantidade de",
          fromSku: "do SKU",
          forTheDay: "para o dia",
          movePlan: "Mover plano",
          approvesAllItems:
            "Aprova todos os Itens na lista abaixo, e avança para a próximo etapa!",
          withoutContract: "Sem contrato!",
          gridItemsUpdatedSuccessfully:
            "Os itens da grid foram atualizados com sucesso!",
          gridItemsProblems:
            "Os itens da grid apresentaram problemas no processamento!",
          rememberOperationWithSap:
            " Lembre-se que essa operação também contempla a INTEGRAÇÃO com SAP!",
          allItemsWereApproved:
            " Todos os itens foram aprovados e encontram-se na próxima etapa do 'WorkFlow'! ",
          allItemsWereNotApproved:
            " Todos os itens NÃO foram aprovados e encontram-se na etapa anterior do 'WorkFlow'!",
          itemsWereNotProcessed:
            " Os itens Não foram processados adequadamente'! ",
          itemUpdatedSuccessfully: "Item atualizado com sucesso!",
          errorSavingItem: "Erro ao salvar o item!",
          exceededMonthlyAmount: "Quantidade informada excedeu o mensal.",
          monthlyTotalReported: "Total mensal informado:",
          maxAvailable: "Máximo disponível:",
          referenceMonthYear: "Mês/ano referência:",
          negativeValues: "Valores negativos não são permitidos!",
          enablesFilteringGrid:
            "Habilita filtrar as linhas da grid abaixo por um range de datas!",
          disableFiltersAndReturn:
            "Desabilita filtro e retorna todas as linhas da grid abaixo!",
          viewRatioData: "Exibir dados de proporção",
          saveChangesToSelectedItem:
            "Salvar alterações no Item selecionado na Grid abaixo, SEM avançar para o próximo etapa!",
          uploadCsvFile: "Carregar arquivo csv e atualizar a lista abaixo!",
          downloadCsvFile:
            "Download o arquivo csv para ser atualizado e carregado!",
          doYouWantContinue: "Deseja continuar o Forecast Diário?",
          reproveAllItems:
            "Reprova todos os Itens na lista abaixo, e os retorna para a etapa anterior!",
          excelImport: "Importação de Planilha Excel!",
          csvWithSuccess: "CSV Processado com Sucesso!",
          csvWithFail: "Não foi possível processar o CSV",
          movePlanWithSuccess: "Plano movido com sucesso!",
          movePlanWithFail: "Não foi possível mover plano!",
          dailyForecastStep: "Forecast Diário Step",
          sapSupplierCode: "Código Fornecedor SAP",
          contractConsume: "Consumo contrato",
          defineBasePlan: "'Definir Plano Base",
          approve: "Aprovar",
          disapprove: "Reprovar",
          itemsReleasedToLaunchProduction:
            "Itens liberados para lançar a Produção",
          optional: "Opcional",
          allStepsCompleted:
            "Todas as etapas foram cumpridas. Inclusive a geração do Forecast. Ainda é possível alterar dados do contrato, Contudo, não será possível recriar o Forecast para os SKU's e o exercício já criado! A etapa final será realizada para os SKU's incluidos após a última geração de Forecast em : Incluir data aqui",
        },
      },
      stuffRequest: {
        titlePage: "Solicitação de Matéria Prima",
        text: {
          indicateNeed: "Indicar Necessidade",
          proposeFulfillment: "Propor de Atendimento",
          partnerAcceptance: "Aceite do Parceiro",
          approveRequestAndGeneratePurchaseOrder:
            "Aprovar Solicitação e Gerar pre-ordem(Compra)",
          requestedItems: "Itens Requisitados",
          rawMaterialRequest: "Solicitação de Matéria Prima",
          itemsSavedSuccessfully: " Itens salvos com sucesso! ",
          errorTryingToSave: " Erro ao tentar salvar! ",
          itemDeletedSuccessfully: " Item excluído com sucesso! ",
          errorTryingToDelete: " Erro ao tentar excluir! ",
          itemSaveSuccessfully: " Item salvo com sucesso! ",
          itemRejectedSuccessfully: " Item reprovado com sucesso! ",
          errorTryingFailed: " Erro ao tentar reprovado! ",
          itemsDeletedSuccessfully: "itens excluídos com sucesso.",
          itemApprovedSuccessfully: " Item aprovado com sucesso! ",
          errorTryingToApprove: " Erro ao tentar aprovar! ",
          proposedDateEarlier:
            "Data Proposta não pode ser anterior a Data de Solicitação!",
          uploadDateEarlier:
            "Data de Carregamento não pode ser anterior a Data de Solicitação!",
          itemAddedSucessfully: " Item incluído com sucesso! ",
          errorTryingToInclude: " Erro ao tentar incluir! ",
          saveChangesToSelectedData:
            "Salvar alterações em todos os itens selecionados na Grid abaixo, SEM avançar para o próximo etapa!",
          enablesFiltering:
            "Habilita filtrar as linhas da grid abaixo por um range de datas!",
          disableFilters:
            "Desabilita filtro e retorna todas as linhas da grid abaixo!",
          addLine: "Adicionar linha",
          uploadCsv: "Carregar arquivo csv e atualizar a lista abaixo!",
          downloadCsv:
            "Download o arquivo csv para ser atualizado e carregado!",
          reproveItemsFromSelectedData:
            "Reprova os dados do(s) Item(ns) selecionado(s) na lista abaixo, e os retorna para a etapa anterior!",
          proceedWithRequest:
            "Deseja prosseguir com a Solicitação de Matéria Prima?",
          deleteSelected: "Excluir Selecionados",
          proceedWithDelete:
            "Deseja prosseguir com a exclusão dos materiais selecionados ?",
          excelImport: "Importação de Planilha Excel!",
          filterGridBy: "Filtrar Grid Por:",
        },
      },
      dailyProductionRelease: {
        titlePage: "Lançamento Diário de Produção",
        text: {
          approveItemData:
            "Aprova os dados do(s) Item(ns) selecionado(s) na lista abaixo, e avança para a próximo etapa!",
          approvalOfDeviations: "Aprovação de desvios",
          thePlural: "Os ",
          itemsSuccessfullyIntegrated:
            " itens selecionados na grid foram integrados com sucesso!",
          itemSuccessfullyIntegrated:
            "O item selecionado na grid foi integrado com sucesso!",
          itemsSuccessfullyUpdated:
            " itens selecionados na grid foram atualizados com sucesso!",
          itemSuccessfullyUpdated:
            "O item selecionado na grid foi atualizado com sucesso!",
          itemsSuccessfullyFail:
            " itens selecionados na grid não foram processados adequadamente!",
          itemSuccessfullyFail:
            "O item selecionado na grid não foi processado adequadamente!",
          adhesionLessThan:
            " Para Aderência menor do que {{valorAderencia}}% é necessário informar os campos: Justificar, Compensa dentro do mês e Quando? ",
          rememberSapIntegration:
            " Lembre-se que essa operação também contempla  a  INTEGRAÇÃO com SAP!",
          itemsApprovedForNextStep:
            " itens selecionados na grid foram aprovados e encontram-se na próxima etapa do 'WorkFlow'! ",
          itemApprovedForNextStep:
            "O item selecionado na grid foi aprovado e encontra-se na próxima etapa do 'WorkFlow'!",
          itemsDontApprovedForNextStep:
            " itens selecionados na grid NÃO foram aprovados e encontram-se na etapa anterior do 'WorkFlow'! ",
          itemDontApprovedForNextStep:
            "O item selecionado na grid NÃO foi aprovado e encontra-se na etapa anterior do 'WorkFlow'!",
          itemsNotProcessedProperly:
            " itens selecionados na grid não foram processados adequadamente'!",
          itemNotProcessedProperly:
            "O item selecionado na grid não foi processado'!",
          payWithinMonth: "Compensa dentro do mês?",
          when: "Quando?",
          for: "Para *",
          negativeValuesNotAllowed: "Valores negativos não são permitidos!",
          enablesFilteringByDate:
            "Habilita filtrar as linhas da grid abaixo por um range de datas!",
          disableFilter:
            "Desabilita filtro e retorna todas as linhas da grid abaixo!",
          moveSelectedLine: "Mover a(s) linha(s) selecionada(s) para o Step 1",
          saveChangesWithoutAdvance:
            "Salvar alterações no Item selecionado na Grid abaixo, SEM avançar para o próximo etapa!",
          wishContinue: "Deseja continuar?",
          reproveDataAndBackStep:
            "Reprova os dados do(s) Item(ns) selecionado(s) na lista abaixo, e os retorna para a etapa anterior!",
          uploadCsvFile: "Carregar arquivo csv e atualizar a lista abaixo!",
          downloadCsvFile:
            "Download o arquivo csv para ser atualizado e carregado!",
          excelImport: "Importação de Planilha Excel!",
          productionRelease: "Lançamento da produção",
          gripConfirmation:
            "Confirmação de Aderência e Integração de produção ao SAP",
        },
      },
      deliveriesFob: {
        pageTitle: "Acompanhamento de Cargas FOB",
        text: {
          requiredField: "Campo Obrigatório!",
          selectPartnerFirst:
            "Você deve selecionar o parceiro antes de acessar esta página.",
          clifor: "Clifor",
          truckPlate: "Placa da Carreta",
          trailerPlate: "Placa do Cavalo",
          orderItems: "Itens do Pedido",
          showOrderItems: "Itens do Pedido",
          enableFiltering: "Habilita filtrar as linhas da grid abaixo!",
          disableFiltering:
            "Desabilita filtro e retorna todas as linhas da grid abaixo!",
          filterFobCargo: "Filtrar Cargas FOB",
          itemsOfOrder: "Items do pedido",
        },
      },
      deliveriesCif: {
        pageTitle: "Acompanhamento de Cargas CIF",
        text: {
          requiredField: "Campo Obrigatório!",
          selectPartnerFirst:
            "Você deve selecionar o parceiro antes de acessar esta página.",
          clifor: "Clifor",
          truckPlate: "Placa da Carreta",
          trailerPlate: "Placa do Cavalo",
          orderItems: "Itens do Pedido",
          showOrderItems: "Itens do Pedido",
          enableFiltering: "Habilita filtrar as linhas da grid abaixo!",
          disableFiltering:
            "Desabilita filtro e retorna todas as linhas da grid abaixo!",
          filterCifCargo: "Filtrar Cargas CIF",
          itemsOfOrder: "Items do pedido",
          loadingHistory: "Histórico de Carregamentos CIF",
          dataSaved: "Os dados foram salvos com sucesso.",
          selectedOrderAndItemNotFound:
            "Pedido e item selecionados não encontrados",
          modalTitle: "Histórico de Carregamentos CIF",
          modalDescriptionSuccess: "Os dados foram salvos com sucesso.",
          modalDescriptionError: "Erro ao salvar alterações.",
          tooltipShowLoadingDeliveries: "Mostrar histórico de carregamentos",
          tooltipDeleteLoadingHistory:
            "Desfazer excluir histórico de carregamentos",
          tooltipAddNewLoad: "Adicionar novo carregamento",
          tooltipDownloadFileAndUpdate:
            "Download do arquivo csv para ser atualizado e carregado!",
          tooltipUploadFileAndUpdateList:
            "Carregar arquivo csv e atualizar a lista abaixo!",
          tooltipSaveChanges: "Salvar todas as alterações feitas.",
          tooltipExitModal: "Sair do modal",
        },
      },
      deliveriesRawMaterial: {
        pageTitle: "Acompanhamento de Cargas de Matéria Prima",
        text: {
          truckPlate: "Placa da Carreta",
          saveAllChanges: "Salvar todas as alterações feitas.",
        },
      },
      stockPartnerBrf: {
        pageTitle: "Estoque/Parceiro BRF",
        text: {
          thisFieldCannotBeEmpty: "Este campo não pode ficar vazio!",
          thisFieldCanOnlyContainNumbers: "Este campo só pode conter números!",
          thisFieldCannotBeLonger:
            "Este campo não pode ter mais que 5 caracteres!",
          unableToFindIndustrializationCenter:
            "Não foi possível encontrar um Centro de Industrialização para este parceiro!",
          csvDownload:
            "Download o arquivo csv para ser atualizado e carregado!",
          brfPartner: "Parceiro BRF",
        },
      },
      stockPartnerNamed: {
        pageTitle: "Estoque/Parceiro ",
        text: {
          thisFieldCannotBeEmpty: "Este campo não pode ficar vazio!",
          thisFieldCanOnlyContainNumbers: "Este campo só pode conter números!",
          thisFieldCannotBeLonger:
            "Este campo não pode ter mais que 5 caracteres!",
          unableToFindIndustrializationCenter:
            "Não foi possível encontrar um Centro de Industrialização para este parceiro!",
          selectPartner: "É necessário selecionar um Parceiro!",
          csvDownload:
            "Download o arquivo csv para ser atualizado e carregado!",
          partner: "Parceiro",
        },
      },
      finishiedProduct: {
        pageTitle: "Produto Acabado",
        text: {
          availableProductsList: "Relação de Produtos Disponíveis",
          prioritizeDeliveries: "Priorizar Entregas",
          generatePreOrder: "Gerar Pré Ordem",
          productsAlreadyRequested: "Produtos já solicitados",
          withoutContract: "Sem Contrato!",
          finishiedProduct: "Produto Acabado",
          inconsistencyInReportedBalance: "Inconsistência no saldo informado",
          have: "Há",
          that: "que",
          exceedingBalance: "excedendo o saldo",
          wantProceed: "Deseja prosseguir sem corrigir?",
          informOriginCenter: "Necessário informar o campo Centro de Origem!",
          informDestinyCenter: "Necessário informar o campo Centro de Destino!",
          informOriginDeposit:
            "Necessário informar o campo Depósito de Origem!",
          informContractSap: "Necessário informar o campo Contrato SAP!",
          deliveryDateCannotBeEarlier:
            "Data de Entrega não pode ser anterior a Data Atual!",
          deliveryDateCannotBeBefor:
            "Data de Entrega não pode ser anterior a Data de Inclusão!",
          quantityMoreThanZero:
            "Quantidade informada deve ser maior do que zero!",
          requiredLoadDate: "Necessário informar uma Data de Carregamento!",
          originDontInformed: "Origem do carregamento não informada.",
          deliveryDateNeedInformed:
            "Necessário informar a data prevista de entrega!",
          requiredDestinyCenter: "Necessário informar o centro de destino!",
          loadingDateMustBeFilled: "Data de carregamento deve ser preenchida",
          thePlural: "Os",
          itemsUpdatedSuccessfully:
            " itens selecionados na grid foram atualizados com sucesso! ",
          itemUpdatedSuccessfully:
            "O item selecionado na grid foi atualizado com sucesso!",
          itemsProcessedWithProblems:
            " itens selecionados na grid apresentaram problemas no processamento! ",
          itemProcessedWithProblems:
            "O item selecionado na grid não foi processado!",
          totalQuantityReported: "Quantidade total informada (em paletes) (",
          isLess: "é inferior a quantidade de Paletização mínima",
          isGreater: "é superior a quantidade de Paletização máxima",
          itemsWithInsufficientBalance:
            "Existem itens com saldo insuficiente para realizar o pedido, verifique a coluna saldo.",
          itemWithInsufficientBalance:
            "Item com saldo insuficiente para realizar pedido, verifique a coluna saldo.",
          insufficientBalance: "Saldo insuficiente",
          wantProceed2:
            "Deseja prosseguir com a requisição de Produto Acabado?",
          cancelSelectedOrder: "Cancelar pedido(s) selecionado(s)",
          moveSelectedOrder:
            "Mover o(s) pedidos(s) selecionado(s) para o Step 2",
          saveChanges:
            "Salvar alterações em todos os itens selecionados na Grid abaixo, SEM avançar para o próximo etapa!",
          goToNextStep: "Ir para a próxima etapa",
          itemApproveSuccessfully: "Item aprovado com sucesso",
          wantProccedClickYes:
            "Se deseja prosseguir com a requisição de produto acabado preencha os dados e clique em SIM.",
        },
      },
      importRequest: {
        pageTitle: "Pedido de Importação",
        text: {
          unableToRecoverDate:
            "Não foi possível recuperar o dados! A aplicação apresentou o seguinte erro :",
          requiredSelectedPartner: "é necessário selecionar um parceiro!",
          dataSavedSuccessfully: "Os dados foram salvos com sucesso.",
          errorProcessingFile: "Erro ao processar arquivo.",
          ordersUpdatedSuccessfully: "Pedidos atualizados com sucesso!",
          orderUpdatedSuccessfully: "Pedido atualizado com sucesso!",
          errorSavingOrders: "Erro ao salvar os pedidos!",
          errorSavingOrder: "Erro ao salvar o pedido!",
          boardingInstructionSequenceNo: "Nº Seq. Inst. Embarque",
          boardingSequenceNo: "Nº Sequência do Embarque",
          purchasingDocument: "Documento de compras - PO",
          item: "Item - PO",
          supplier: "Fornecedor - PO",
          name: "Nome - PO",
          materialPo: "Material - PO",
          acronym: "Sigla - PO",
          description: "Texto breve - PO",
          orderQuantity: "Qtd. do pedido - PO",
          shipmentQuantity: "Qtde Embarque - BEM",
          etd: "ETD",
          eta: "ETA",
          shippingDate: "Data Remessa",
          estatiscalShippingDate: "Data Remessa - Estatística",
          commodityReceiptDate: "Data Recebimento Mercadoria",
          registrationDate: "Data Registro - DES",
          month: "Mês",
          week: "Semana",
          deviationReceiving: "Desvio Recebimento",
          justify: "Justificativa",
          causer: "Causador",
          observation: "Observação",
          orderIntegratedSuccessfully: " Pedido(s) integrado(s) com sucesso! ",
          errorInIntegration: " Erro ao tentar Integrar!",
          justifyRequest:
            " Necessário informar Justificativa para Desvio de Recebimento maior do que +- 7 dias úteis! ",
          saveAllLines: "Salvar todas as linhas.",
          csvDownload: "Download do arquivo csv para atualização em lote.",
          loadCsvFile: "Carregar arquivo csv.",
          watchOrderHistory: "Ver o histórico de pedidos de importação.",
          filter: "Filtrar",
          sapIntegrate: "Integrar SAP",
          config: "Configurações",
          filterImportOrders: "Filtrar Pedidos de Importação",
          order: "Pedido",
          material: "Material",
          shippingInstruction: "Instrução de Embarque",
          sheetImport: "Importação de Planilha Excel!",
          daysBetweenRequired: "O parâmetro 'dias entre' deve ser preenchido.",
          timeRequired: "O parâmetro 'hora' deve ser preenchido.",
          saveConfigs: "Salvar configurações",
          exitConfigs: "Sair das configurações",
          waitPlease: "Aguarde por favor ..",
          differenceLimit:
            "Limite de diferença em dias entre ETA e Data Remessa: ",
          timeForAutomaticRoutine: "Hora para execução da rotina automática: ",
          exitModal: "Sair do modal",
          eventDate: "Data do Evento",
          orderImportId: "ID do Pedido de Importação",
          responsible: "Responsável",
          csvDownload2:
            "Download o arquivo csv para ser atualizado e carregado!",
          orderHistory: "Histórico de Pedidos de Importação",
        },
      },
      dashboardProductionMonitoring: {
        pageTitle: "Dashboard Acompanhamento de Produçao",
        text: {
          otif: "OTIF",
          downloadCsv:
            "Download o arquivo csv para ser atualizado e carregado!",
          initial: "Inicial",
          final: "Final",
          dateTypeDoesNotExist: "Tipo de data não existe:",
          loadingDataWaitPlease: "Carregando dados, aguarde por favor ...",
          percentageOfJustifications: "Porcentagem de justificativas:",
          initialDate: "Data de Início",
          finalDate: "Data Final",
          portalContract: "Portal Contrato",
          partners: "Parceiros",
          updateDashboardWithFilters:
            "Atualizar dashboard com os filtros selecionados",
          applyFilters: "Aplicar filtros",
          filterDate:
            "O filtro data sempre irá ajustar as datas para inicio e fim da semana.",
          contractFilter:
            "O filtro de contrato é preenchido de acordo com o(s) parceiro(s) selecionado(s).",
          plannedProducedWeekly: "PLANEJADO X PRODUZIDO SEMANAL",
          plannedProducedDaily: "PLANEJADO X PRODUZIDO DIÁRIO",
          justifications: "JUSTIFICATIVAS",
          total: "TOTAL",
          remnant: "SOBRAS",
          breaking: "QUEBRA",
          quantity: "QUANTIDADE",
          planned: "PLANEJADA",
          produced: "PRODUZIDA",
        },
      },
      dashboardContractualComsumption: {
        pageTitle: "Dashboard Consumo Contratual",
        text: {
          contractualComsumption: "Consumo Contratual",
          loadingData: "Carregando dados, aguarde por favor...",
          portalContract: "CONTRATO PORTAL",
          sapContract: "CONTRATO SAP",
          updateDashboardWithSelectedFilters:
            "Atualizar dashboard com filtros selecionados",
          minimal: "MÍNIMA",
          variation: "VARIAÇÃO",
          maximum: "MÁXIMA",
          percentageByContractTime: "Porcentagem por Tempo de Contrato",
          volume: "VOLUME",
          consumed: "CONSUMIDO",
          totalContract: "TOTAL DO CONTRATO",
          percentageOfQuantityProducedBeforeTheTotalPlan:
            "Porcentagem de quantidade produzida perante a planejada total",
          portalContractNumber: "Nº de Contrato do Portal",
          sapContractNumber: "Nº de Contrato do SAP",
          downloadCsv:
            "Download o arquivo csv para ser atualizado e carregado!",
        },
      },
      dashboardImport: {
        pageTitle: "Dashboard Importação",
        text: {
          import: "Importação",
          seqNoBoardingInstruction: "Nº Seq. Instrução Embarque",
          boardingSequenceNumber: "Nº Sequência do Embarque",
          csvDownload:
            "Download o arquivo csv para ser atualizado e carregado!",
          withoutStatus: " SEM STATUS",
          loadingDataPleaseWait: "Carregando dados, aguarde por favor ...",
          startDate: "Data de Início",
          finalDate: "Data Final",
          partners: "Parceiros",
          updateDashboardWithSelectedFilters:
            "Atualizar dashboard com os filtros selecionados",
          applyFilters: "Aplicar Filtros",
          deviationsDividedByCause: "DESVIOS DIVIDIDOS POR CAUSADOR",
          deviationsDividedByJustification:
            "DESVIOS DIVIDIDOS POR JUSTIFICATIVA",
          adherence: "ADERÊNCIA",
          quantity: "QUANTIDADE",
          staticDate: "DATA ESTÁTICA",
          shippingDate: "DATA REMESSA",
          requestVersusReceiving: "SOLICITAÇÃO X RECEBIMENTO",
          period: "PERÍODO",
          requested: "SOLICITADA",
          received: "RECEBIDA",
          amountToReceive: "QUANTIDADE A RECEBER",
        },
      },
      dashboardTracking: {
        pageTitle: "Dashboard Acompanhamento de Parceiros",
        text: {
          dataTypeDoesNotExist: "Tipo de data não existe:",
          loadingDataPleaseWait: "Carregando dados, aguarde por favor ...",
          justifyPercentage: "Porcentagem de justificativas:",
          portalContract: "Contrato Portal",
          updateDashboardWithFilteredDara:
            "Atualizar dashboard com os filtros selecionados",
          applyFilters: "Aplicar filtros",
          dateFilter:
            "O filtro data sempre irá ajustar as datas para inicio e fim da semana.",
          contractFilter:
            "O filtro de contrato é preenchido de acordo com o(s) parceiro(s) selecionado(s).",
          planned: "PLANEJADO",
          weeklyDelivered: "ENTREGA SEMANAL",
          justification: "JUSTIFICATIVAS",
          total: "TOTAL",
          over: "SOBRA",
          break: "QUEBRA",
          dailyDelivered: "ENTREGA DIÁRIA",
          quantity: "QUANTIDADE",
          delivered: "ENTREGUE",
          received: "RECEBIDO",
          downloadCsvFile:
            "Download o arquivo csv para ser atualizado e carregado!",
        },
      },
      login: {
        fields: {
          email: "Email",
          password: "Senha",
        },
        pageTitle: "Login",
        text: {
          subtitle: "Acesse com sua conta corporativa.",
          login: "Entrar",
          loginFailed: "Falha no login",
          checkUserPassAndTryAgain:
            "Verifique suas credenciais e tente novamente.",
          rememberMe: "Lembrar-me",
          or: "ou",
          microsoftAuth: "Entrar com Microsoft",
          forgotPassword: "Esqueceu a senha?",
          backToHome: "Voltar ao início",
          email: "E-mail",
          password: "Senha",
          enter: "Entrar",
          emailRequired: "E-mail é obrigatório",
          passwordRequired: "Senha é obrigatória",
          invalidEmail: "E-mail inválido",
          invalidPassword: "Senha inválida",
          invalidCredentials: "Credenciais inválidas",
          error: "Erro",
          ok: "Ok",
          trygain: "Tentar novamente",
        },
      },
    },
    common: {
      id: "ID",
      name: "Nome",
      password: "Senha",
      nickname: "Apelido",
      email: "E-mail",
      emails: "E-mails",
      group: "Grupo",
      groups: "Grupos",
      address: "Endereço",
      complement: "Complemento",
      neighborhood: "Bairro",
      city: "Cidade",
      state: "Estado/Província/Região",
      stateAbbreviation: "UF",
      country: "País",
      postalCode: "CEP",
      phone: "Telefone",
      contact: "Contato",
      contactPhone: "Telefone do Contato",
      website: "Site",
      yes: "Sim",
      no: "Não",
      ok: "Ok",
      add: "Adicionar",
      delete: "Excluir",
      close: "Fechar",
      apply: "Aplicar",
      cancel: "Cancelar",
      continue: "Continuar",
      warning: "Aviso!",
      attention: "ATENÇÃO!",
      Informative: "Informativo!",
      error: "Erro!",
      field: "Campo",
      fields: "Campos",
      value: "Valor",
      createdAt: "Criado Em",
      acronym: "Sigla",
      sku: "Sku",
      skus: "Skus",
      skuId: "ID sku",
      skuCode: "Código Sku",
      skuDescription: {
        label: "Descrição Sku",
        placeholder: "Informe a descrição do sku",
      },
      description: "Descrição",
      language: "Idioma",
      basicUnit: "Unidade Básica",
      materialType: "Tipo Material",
      materialTypeDescription: "Descrição Tipo Material",
      center: "Centro",
      centerDescription: "Centro - Descrição",
      distributionCenter: {
        label: "Centro de distribuição",
        placeholder: "Informe o centro",
      },
      local: "Local",
      category: "Categoria",
      release: "Lançamento",
      order: "Pedido",
      causer: "Causador",
      back: "Voltar",
      project: "Projeto",
      quantity: "Quantidade",
      actions: "Ações",
      origin: "Origem",
      origins: "Origens",
      skip: "Pular",
      historic: "Histórico",
      viewHistoric: "Visualizar histórico",
      plannedQuantity: "Quantidade planejada",
      proposedQuantity: "Quantidade proposta",
      producedQuantity: "Quantidade produzida",
      orderQuantity: "Quantidade do pedido",
      justify: "Justificar",
      generatedDiary: "Gerou diário",
      filter: "Filtro",
      filtered: "Filtrar",
      seeDetails: "Ver detalhes",
      monthYearRef: "Mês ano ref.",
      date: "Data",
      initialDate: "Data inicial",
      finalDate: "Data final",
      contractNumber: "Número do contrato",
      percentageConsumed: "Percentual Consumido",
      day: "Dia",
      requestedIn: "Solicitado em",
      for: "Para",
      requestedSku: "SKU - solicitado",
      requestedSkuId: "ID SKU - solicitado",
      selectedQuantity: "Qtde. Solicitado",
      requestJustify: "Justificativa da Solicitação",
      loadDate: "Data carregamento",
      proposalDate: "Data Proposta",
      proposalSku: "SKU - Proposto",
      proposalSkuId: "ID SKU - Proposto",
      proposalQuantity: "Qtde. Proposta",
      proposalJustify: "Justificativa Proposta",
      warehouse: "Depósito",
      contract: "Contrato",
      contractSap: "Contrato SAP",
      observationRule: "Norma da observação",
      exclusion: "Exclusão",
      finish: "Finalizar",
      next: "Próximo",
      prev: "Anterior",
      csvWithSuccess: "CSV Processado com Sucesso!",
      csvWithError: "Não foi possível processar o CSV",
      grip: "Aderência",
      shipmentDate: "Data da remessa",
      deliveryDate: "Data da entrega",
      shipping: "Remessa",
      orderNumber: "Número do Pedido",
      itemNumber: "Número do Item",
      item: "Item",
      items: "Itens",
      balance: "Saldo",
      amountReceived: "Quantidade Recebida",
      quantityLoaded: "Quantidade Carregada",
      expectedDeliveryDate: "Data Prevista de Entrega",
      sapDeliveryDate: "Data de Entrega SAP",
      lastLoadDate: "Data do Último Carregamento",
      destination: "Destino",
      loadHistory: "Histórico de Carregamentos",
      showLoadHistory: "Exibir Histórico de Carregamentos",
      originCenter: "Centro de Origem",
      boardingDate: "Data de Embarque",
      invoice: "NF",
      observations: "Observações",
      report: "Laudo",
      attachReport: "Anexar Laudo",
      downloadReport: "Baixar Laudo",
      deleteReport: "Apagar Laudo",
      measurementUnit: "Unidade de Medida",
      save: "Salvar",
      material: "Material",
      materialDescription: "Material - Descrição",
      sapQuantity: "Quantidade SAP",
      partnerQuantity: "Quantidade Parceiro",
      distinction: "Diferença",
      otpions: "Opções",
      edit: "Editar",
      skuIdDelivery: "ID SKU - A Entregar",
      palletizing: "Paletização",
      loadingDate: "Data de Carregamento",
      loading: "Carregamento",
      originDeposit: "Depósito de Origem",
      destinationCenter: "Centro de Destino",
      destinationDeposit: "Depósito de Destino",
      itIs: "Está",
      are: "Estão",
      noResults: "Sem resultados",
      step: "Passo",
      searchDistributionCenter: "Buscar Centro Distribuição",
      statusBooking: "Status da Reserva",
      canceled: "CANCELADO",
      reset: "Resetar",
      partner: "Parceiro",
      partners: "Parceiros",
      week: "Semana",
      status: "Status",
      deviation: "Desvio",
      recover: "Recupera",
      compensationDate: "Data compensação",
      compensationWeek: "Semana compensação",
      accomplishedQuantity: "Quantidade realizada",
      quantityDeviation: "Quantidade Desvio",
      compensation: "Compensa",
      compensationQuantity: "Quantidade Compensação",
      weekCompensation: "Semana Compensação",
      contractTotalQuantiy: "Quantidade Total Contrato",
      percentageProduced: "Porcentagem Produzida",
      percentageOfContractTime: "Porcentagem do Tempo de Contrato",
      endDate: "Data de Término",
      minimalVariation: "Variação Mínima",
      maximumVariation: "Variação Máxima",
      requested: "Solicitado",
      received: "Recebido",
      water: "ÁGUA",
      harbor: "PORTO",
      awaitingBilling: "AGUARDA FATURAMENTO",
      bookingStatus: "Status booking",
      purchasingDocument: "Documento de compras",
      shipmentQuantity: "Qtde embarque",
      staticShippingDate: "Data remessa estática",
      stockEntryForecast: "Previsão entrada estoque",
      entryIntoStock: "Entrada no estoque",
      deliveredQuantity: "Quantidade entregue",
      justification: "Justificativa",
      otif: "OTIF",
      fileUpload: {
        resultProcessingFile: "Resultado do processamento do arquivo: ",
        fileSize: "Tamanho do arquivo em bytes: ",
        lastModifiedDate: "Data da última modificação: ",
        submit: "Enviar",
        selectFileForDetails:
          "Selecione um arquivo .csv para ver os detalhes...",
        uploadFile: "Carregar arquivo",
        selectFileFirst: "Selecione um arquivo primeiro",
      },
      stepLogsHistoryDetalhe: {
        modal: {
          title: "Histórico de alterações do item id {{id}} do {{name}}",
        },
      },
      dashboardFilters: {
        form: {
          label: "Que tipo de dados gostaria de carregar?",
          buttonGeneralData: "Dados gerais",
          buttonSpecieficPartner: "Parceiro específico",
          errorDate: "É necessário escolher uma data de inicio e data de fim!",
          maxDateError: "O período escolhido não pode ser maior que 90 dias!",
          lastQuarter: "Último trimestre",
          specificPeriod: "Período específico",
          startDate: "Data de início",
          endDate: "Data de final",
          loadData: "Buscar dados e carregar dashboard",
        },
      },
      autoComplete: {
        centro: {
          label: "Buscar centro distribuição",
        },
        centroVirtual: {
          label: "Buscar centro virtual",
        },
        contrato: {
          label: "Buscar contrato",
        },
        email: {
          label: "Buscar e-mail",
        },
        justificativa: {
          label: "Buscar justificativa",
        },
        listaTecnica: {
          label: "Buscar SKU",
        },
        parceiro: {
          label: "Buscar parceiro",
        },
        projeto: {
          label: "Buscar projeto",
        },
        propriedade: {
          label: "Buscar parâmetro",
        },
      },
    },
    global: {
      button: {
        new: "Novo",
        edit: "Editar",
        delete: "Excluir",
        save: "Salvar",
        cancel: "Cancelar",
        back: "Voltar",
        search: "Buscar",
        filter: "Filtrar",
        clear: "Limpar",
        close: "Fechar",
        add: "Adicionar",
        remove: "Remover",
        yes: "Sim",
        no: "Não",
        ok: "Ok",
        apply: "Aplicar",
        reset: "Resetar",
        download: "Download",
        upload: "Upload",
        approve: "Aprovar",
        disapprove: "Reprovar",
        proceed: "Prosseguir",
        continue: "Continuar",
        send: "Enviar",
        generate: "Gerar",
        view: "Visualizar",
        confirm: "Confirmar",
        exit: "Sair",
        step: "Passo",
        skip: "Pular",
      },
      table: {
        dateAndHour: "Data e hora",
        user: "Usuário",
        description: "Descrição",
        contractNumber: "Nº do contrato",
        freight: "Frete",
        startVigency: "Início vigência",
        endVigency: "Fim da vigência",
        itemQuantity: "Qtd de itens",
        consumption: "Consumo",
        seeDetails: "Ver detalhes",
        group: "Grupo",
        parameter: "Parâmetro",
        value: "Valor",
        order: "Pedido",
        item: "Item",
        skuDescription: "Descrição SKU",
        loadedQuantity: "Qtd carregada",
        loadingDate: "Data carregamento",
        deliveryDate: "Data de entrega",
        truckPlate: "Placa da carreta",
        truckHorsePlate: "Placa do cavalo",
        breakQuantity: "Qtd de quebra",
        breakJustification: "Justificativa de quebra",
        sapCode: "Código SAP",
        day: "Dia",
        partner: "Parceiro",
        contract: "Contrato",
        skuId: "ID SKU",
        productionMade: "Produção realizada",
        productionReceived: "Produção recebida",
        justification: "Justificativa",
        averagePrice: "Preço médio",
        activity: "Atividade",
        subActivity: "Sub atividade",
        family: "Família",
        subGroup: "Sub grupo",
        center: "Centro",
        protein: "Proteína",
        week: "Semana",
        sapContract: "Contrato SAP",
        origin: "Origem",
        name: "Nome",
        reference: "Referência",
        status: "Status",
        step: "Passo",
        partnerAggregated: "Parceiro agregado",
      },
      tooltip: {
        downloadFileAndUpdate:
          "Download do arquivo csv para ser atualizado e carregado!",
        deleteOrigin: "Excluir origem",
        changesHistory: "Histórico de alterações",
        addNewOrigin: "Adicionar nova origem",
        closeModal: "Fechar modal",
        newParameter: "Novo parâmetro",
        updateParameter: "Parâmetro atualizado",
      },
      message: {
        rowUpdatedSuccessfully: "Registro atualizado com sucesso!",
        rowUpdatedFillingTheFields:
          "Registro adicionado, por favor preencha os dados na grid.",
        rowDeletedSuccessfully: "Registro removido com sucesso!",
        warning: "Atenção!",
        selectPartner:
          "Para utilizar essa funcionalidade, é necessário selecionar um parceiro!",
        selectPartnerFirst:
          "Você precisa selecionar um parceiro antes de acessar esta funcionalidade.",
        selectPartnerToContinue:
          "Para acessar esta funcionalidade, você precisa selecionar um parceiro primeiro.",
        selectPartnerBelow:
          "Selecione um parceiro abaixo para continuar:",
        partnerSelectionRequired: "Seleção de parceiro necessária",
        partnerSelectionHint:
          "Dica: Você pode trocar de parceiro a qualquer momento clicando no ícone ao lado do nome do parceiro no cabeçalho.",
        parameterDeleted: "Parâmetro excluído com sucesso!",
        partnerAdded: "Parceiro agregado adicionado com sucesso!",
        partnerUpdated: "Parceiro agregado atualizado com sucesso!",
        propertyAddWithSuccess: "Propriedade adicionada com sucesso!",
        propertyUpdatedWithSuccess: "Propriedade atualizada com sucesso!",
      },
      dialog: {
        deletePartnerAggregated:
          "Deseja realmente excluir o parceiro agregado?",
        deletePartnerAggregatedSubTitle:
          "Você solicitou a exclusão do Parceiro Agregado.",
        providerCode: "Código do Fornecedor: ",
        confirmOperation: "Confirma a operação?",
      },
    },
  },
};
